module.exports = __webpack_public_path__ + "static/6-3cbb131d260390ce63b911ca46360ac9.jpg";